import { z } from 'zod';
import { HerkunftFelder } from './auftrag-zusammenfuehren.js';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

export const KiBriefingSchema = z
  .object({
    ki_briefing_id: UuidSchema,
    project_id: UuidSchema,
    body: z.string(),
    model: z.string().nullable().optional(),
    prompt_metadata: z.record(z.string(), z.unknown()).nullable().optional(),
    created_at: IsoDateTimeSchema,
    created_by: UuidSchema.nullable().optional(),
  })
  .extend(HerkunftFelder);
export type KiBriefing = z.infer<typeof KiBriefingSchema>;

export const HardStopErrorSchema = z.object({
  message: z.literal('hard_stop_violation'),
  errors: z.array(
    z.object({
      field: z.string(),
      reason: z.enum(['missing', 'invalid']),
      direction: z.enum(['leave', 'enter']),
    }),
  ),
});
export type HardStopError = z.infer<typeof HardStopErrorSchema>;
